import { hasQueryOverrides } from 'components/V5Gadget/seriesDataKey';

export interface OverrideGroup {
  // Stable across renders while the overrides are unchanged
  key: string;
  overrides: V5SeriesQueryOverrides;
  series: V5ChartDefinitionSeries[];
}

const toSignature = (overrides: V5SeriesQueryOverrides): string =>
  JSON.stringify({
    isFiltersOverridden: !!overrides.isFiltersOverridden,
    filters: overrides.filters || [],
    dateOffset:
      overrides.dateOffset && overrides.dateOffset.count > 0
        ? overrides.dateOffset
        : null,
    dateField: overrides.dateField || null,
  });

/**
 * Splits a chart's series into the ones that share the chart's query (base)
 * and one group per distinct set of query overrides. Series in a group ask the
 * same question, so a group is fetched with one request.
 */
const groupSeriesByOverrides = (
  chartDef: V5ChartDefinition,
): { base: V5ChartDefinitionSeries[]; groups: OverrideGroup[] } => {
  const base: V5ChartDefinitionSeries[] = [];
  const groups: OverrideGroup[] = [];

  chartDef.series.forEach((series) => {
    const { queryOverrides } = series;
    if (!hasQueryOverrides(queryOverrides)) {
      base.push(series);
      return;
    }

    const key = toSignature(queryOverrides);
    const group = groups.find((g) => g.key === key);
    if (group) {
      group.series.push(series);
    } else {
      groups.push({ key, overrides: queryOverrides, series: [series] });
    }
  });

  return { base, groups };
};

export default groupSeriesByOverrides;
